import { MuiTheme } from "theme";
import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles((theme: MuiTheme) => ({
  menuIcon: {
    color: theme.palette.text.primary
  },
  link: {
    textDecoration: "none"
  }
}));
